'use strict';

require('../CompanyService.js');

function CompanySettingStatusesCtrl(
  $scope,
  priorities,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyService,
  growl
) {
  $scope.priorities = priorities;
  $scope.translations = translations;


  $scope.addPriority = function() {
    $scope.priorities.push({
      name: '',
      color: 4279856278, // #196c96
    });

    $scope.lastItem = $scope.priorities.length - 1;
  };

  $scope.savePriorities = function() {
    CompanyService.updatePriorities({companyId: $stateParams.companyId}, $scope.priorities, function() {
      $window.location.reload();
      growl.addSuccessMessage(translations['settings.save-priorities-success']);
    });
  };
}

CompanySettingStatusesCtrl.resolve = {
  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryPriorities({companyId: $stateParams.companyId, name: 'klar'}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'settings.save-priorities-success'
    ]);
  }]
};
module.exports = CompanySettingStatusesCtrl;

angular.module('dokiv')
  .controller('CompanySettingStatusesCtrl', [
  '$scope',
  'priorities',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyService',
  'growl',
  CompanySettingStatusesCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingStatusesCtrl.js
// module id = 412
// module chunks = 0